import { IPaginatedResponse, IPagination } from '@sdk/contracts';
import { createQueryString } from '@utils';

import { RequestService } from '../request/request.service';

import { IAcademy } from './academy.contract';

export class AcademyService extends RequestService {
  public constructor(apiUrl: string) {
    super(apiUrl);
  }

  public getAcademies = async (pagination?: IPagination) => {
    const query = createQueryString({
      limit: pagination?.limit,
      page: pagination?.page
    });
    return this.fetcher<IPaginatedResponse<IAcademy>>(`/academies?${query}`);
  };

  public createAcademy = async (academy: IAcademy) => {
    return this.poster<IAcademy, IAcademy>('/academies', academy);
  };

  public getAcademy = async (academyId: string) => {
    return this.fetcher<IAcademy>(`/academies/${academyId}`);
  };

  public updateAcademy = async (academyId: string, update: Partial<IAcademy>) => {
    return this.putter<IAcademy, Partial<IAcademy>>(`/academies/${academyId}`, update);
  };

  public removeAcademy = async (academyId: string) => {
    return this.deleter(`/academies/${academyId}`);
  };

  public getAcademyByDomain = async (domain: string) => {
    return this.fetcher<IAcademy>(`/academies/by-domain/${domain}`);
  };
}
